import React, { createContext, useContext, useState, ReactNode } from "react";

interface AdminContextType {
  isEditingPunishment: boolean;
  isEditingDraftIdeas: boolean;
  setIsEditingPunishment: (value: boolean) => void;
  setIsEditingDraftIdeas: (value: boolean) => void;
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export const AdminProvider = ({ children }: { children: ReactNode }) => {
  const [isEditingPunishment, setIsEditingPunishment] = useState(false);
  const [isEditingDraftIdeas, setIsEditingDraftIdeas] = useState(false);

  return (
    <AdminContext.Provider
      value={{
        isEditingPunishment,
        setIsEditingPunishment,
        isEditingDraftIdeas,
        setIsEditingDraftIdeas,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdminContext = () => {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error("useAdminContext must be used within an AdminProvider");
  }
  return context;
};
